import { AsyncPipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { UtilityService } from "@core/utility.service";
import { IonicModule } from "@ionic/angular";
import { GameBalanceService } from "src/app/services/game-balance.service";
import { HomeDataService } from "src/app/services/home-data.service";

@Component({
  selector: "app-splash",
  templateUrl: "./splash.component.html",
  styleUrls: ["./splash.component.scss"],
  standalone: true,
  imports: [IonicModule, AsyncPipe],
})
export class SplashComponent implements OnInit {
  constructor(
    private router: Router,
    private authService: AuthService,
    private homeDataService: HomeDataService,
    private gameBalanceService: GameBalanceService,
    private utilityService: UtilityService,
  ) { }
  languageList$ = this.utilityService.getLanguageList();
  homePageData$ = this.homeDataService.homeCards$;
  lotteryLInes$ = this.authService.lotteryLInes$;
  charity$ = this.gameBalanceService.charityGlobal$;

  ngOnInit() {
    this.router.navigateByUrl("/mainTabs/tabs/home");
  }
}
